<template>
  <div v-if="isVisible" class="asCookieConsent" data-cy="cookieConsent">
    <div class="asCookieConsent_wrapper">
      <p class="asCookieConsent_text">
        {{ $t('cookieConsent.text') }}
        <a
          class="asCookieConsent_link"
          data-cy="cookieConsent_policyLink"
          :href="policyLink"
          target="_blank"
          rel="noopener noreferrer"
        >{{ $t('cookieConsent.policy') }}</a>.
      </p>

      <ac-button
        class="asCookieConsent_button"
        type="button"
        data-cy="cookieConsent_accept"
        @click="accept"
      >
        {{ $t('cookieConsent.accept') }}
      </ac-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import AcButton from '@ui-kit/components/AcButton.vue'
import getBaseUrl from '@web/common/getBaseUrl'
import { useCookieConsent } from '@web/platform.v3/composables/useCookieConsent'

const { isVisible, accept } = useCookieConsent()

const policyLink = getBaseUrl('/docs/personal_data.pdf')
</script>

<style lang="scss" scoped>
.asCookieConsent {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  // Ниже AcCookie (99998) и модалок (99999), чтобы не перекрывать диалоги
  z-index: 99997;
  background-color: var(--ac-color-white);
  border-radius: 8px 8px 0 0;
  box-shadow: 0 -2px 12px rgb(0 0 0 / 12%);

  &_wrapper {
    margin: 0 auto;
    max-width: 1200px;
    width: 100%;
    padding: 16px 30px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
    gap: 24px;

    @media (max-width: 962px) {
      flex-flow: column nowrap;
      align-items: flex-start;
      gap: 16px;
      padding: 16px;
    }
  }

  &_text {
    margin: 0;
    font-family: Inter, sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: var(--ac-color-black);
  }

  &_link {
    color: var(--ac-color-deep-liliac);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &_button {
    white-space: nowrap;
    flex-shrink: 0;

    @media (max-width: 962px) {
      width: 100%;
    }
  }
}
</style>
